const en = {
  'app.title': 'Stereogram Studio',
  'nav.studio': 'Create',
  'nav.animate': 'Animate',
  'nav.gallery': 'Gallery',
  'mode.full': 'home · GPU',
  'mode.clientOnly': 'in-browser',
  'mode.hint': 'Where computations run',

  'common.add': 'Add',
  'common.remove': 'Remove',
  'common.reset': 'Reset',
  'common.off': 'off',
  'common.cancel': 'Cancel',

  'time.seconds': '{n} s',
  'time.minutes': '{n} min',
  'time.minSec': '{m} min {s} s',
  'eta.about': '~{t}',

  'error.decode': 'Could not read file: {msg}',
  'error.font': 'Could not load font: {msg}',

  'source.title': 'Source',
  'source.text': '3D text',
  'source.image': 'Image',
  'source.depth': 'Depth map',
  'source.dropImage': 'Drop an image or click to choose',
  'source.dropDepth': 'Drop a depth map (PNG16 preferred) or click',
  'source.depthHint': 'White = near, black = far. 16-bit grayscale PNG keeps full precision.',
  'source.method': 'Depth estimation',

  'heuristic.brightness': 'Brightness (lighter = nearer)',
  'heuristic.edges': 'Edges (enclosed shapes bulge)',
  'heuristic.threshold': 'Edge threshold',

  'text.content': 'Text',
  'text.font': 'Font',
  'text.uploadFont': 'Upload TTF/OTF',
  'text.fill': 'Size in frame',
  'text.extrude': 'Extrusion',
  'text.bevel': 'Bevel',
  'text.base': 'Back depth',
  'text.top': 'Front depth',
  'text.rotX': 'Tilt X',
  'text.rotY': 'Turn Y',
  'text.rotZ': 'Roll Z',

  'output.title': 'Output',
  'output.width': 'Width',
  'output.height': 'Height',
  'output.maxSide': 'Longest side',
  'output.result': 'Result: {w}×{h}',

  'depth.title': 'Depth processing',
  'depth.normalize': 'Normalize',
  'depth.invert': 'Invert',
  'depth.clip': 'Clip outliers',
  'depth.far': 'Far cut',
  'depth.near': 'Near cut',
  'depth.gamma': 'Gamma',
  'depth.smoothing': 'Edge-aware smoothing',
  'depth.smooth.none': 'None',
  'depth.smooth.bilateral': 'Bilateral',
  'depth.smooth.guided': 'Guided',
  'depth.radius': 'Radius',
  'depth.blur': 'Blur',
  'depth.levels': 'Layers',
  'depth.rangeMin': 'Output min',
  'depth.rangeMax': 'Output max',

  'texture.title': 'Texture',
  'texture.kind': 'Pattern',
  'texture.kind.random_dots': 'Random dots (SIRDS)',
  'texture.kind.noise': 'Perlin noise',
  'texture.kind.worley': 'Cells (Worley)',
  'texture.kind.stripes': 'Stripes',
  'texture.kind.marble': 'Marble',
  'texture.kind.camo': 'Camouflage',
  'texture.kind.image': 'My image',
  'texture.kind.source': 'Colours from source',
  'texture.style.bw': 'B/W',
  'texture.style.color': 'Colour',
  'texture.style.palette': 'Palette',
  'texture.density': 'Density',
  'texture.dotSize': 'Dot size',
  'texture.palette': 'Palette',
  'texture.color': 'Colour',
  'texture.scale': 'Scale',
  'texture.octaves': 'Detail (octaves)',
  'texture.stripeWidth': 'Stripe width',
  'texture.waviness': 'Waviness',
  'texture.turbulence': 'Turbulence',
  'texture.upload': 'Drop a texture image or click',
  'texture.needImage': 'Upload a texture image.',
  'texture.seamless': 'Make seamless',
  'texture.seamless.blend': 'Blend edges',
  'texture.seamless.mirror': 'Mirror',
  'texture.seamless.none': 'As is',
  'texture.sourceHint':
    'A grey dot pattern carries the depth and takes the colours of the source image, so the photo shows through the 3D picture.',

  'stereo.title': 'Stereogram',
  'stereo.wallEyed': 'Parallel (wall-eyed)',
  'stereo.crossEyed': 'Cross-eyed',
  'stereo.patternWidth': 'Pattern width',
  'stereo.patternWidthHint': 'Repeat distance of the background. Auto derives it from eye separation and DPI.',
  'stereo.auto': 'auto · {px} px',
  'stereo.eyeSep': 'Eye separation, mm',
  'stereo.dpi': 'Screen DPI',
  'stereo.mu': 'Depth of field (μ)',
  'stereo.muHint': 'How far the scene extends towards the viewer. Larger is deeper but harder to fuse.',
  'stereo.oversample': 'Oversampling',
  'stereo.oversampleHint': 'Horizontal supersampling: smoother depth steps, slower.',
  'stereo.seed': 'Seed',
  'stereo.randomSeed': 'Random seed',
  'stereo.guideDots': 'Guide dots',

  'preview.stereogram': 'Stereogram',
  'preview.depth': 'Depth',
  'preview.texture': 'Texture',
  'preview.fit': 'Fit',
  'preview.rendering': 'Rendering…',
  'preview.empty': 'Choose a source on the left',
  'preview.downloadPng': 'Download PNG',
  'preview.downloadDepth': 'Depth PNG16',
  'preview.depth16Hint': 'Processed depth map as a 16-bit grayscale PNG',

  'anim.source': 'Animation source',
  'anim.procedural': 'Procedural',
  'anim.sequence': 'Depth sequence',
  'anim.preset': 'Motion',
  'anim.preset.turn': 'Full turn (Y)',
  'anim.preset.swing': 'Swing (Y)',
  'anim.preset.tilt': 'Nod (X)',
  'anim.preset.spin': 'Spin (Z)',
  'anim.preset.jump': 'Jump',
  'anim.preset.pulse': 'Pulse',
  'anim.preset.wave': 'Wave',
  'anim.amount': 'Amount',
  'anim.cycles': 'Repeats per loop',
  'anim.proc.waves': 'Waves',
  'anim.proc.noise': 'Noise',
  'anim.proc.ripple': 'Ripple',
  'anim.amplitude': 'Amplitude',
  'anim.wavelength': 'Wavelength',
  'anim.direction': 'Direction',
  'anim.decay': 'Fade with distance',
  'anim.centerX': 'Centre X',
  'anim.centerY': 'Centre Y',
  'anim.base': 'Over',
  'anim.base.flat': 'Flat background',
  'anim.base.studio': 'Static source from “Create”',
  'anim.dropZip': 'Drop a ZIP of PNG16 depth frames or click',
  'anim.noPngInZip': 'The archive contains no PNG files',
  'anim.mixedSizes': 'All frames must have the same size',
  'anim.filter': 'Temporal smoothing',
  'anim.filter.none': 'None',
  'anim.filter.ema': 'Exponential (EMA)',
  'anim.filter.median': 'Median over window',
  'anim.emaAlpha': 'Responsiveness',
  'anim.medianRadius': 'Window radius',
  'anim.threshold': 'Motion threshold',
  'anim.thresholdHint': 'Changes larger than this pass through unsmoothed, so fast motion is not smeared.',
  'anim.timing': 'Timing & size',
  'anim.fps': 'FPS',
  'anim.duration': 'Duration',
  'anim.loop': 'Loop',
  'anim.pingPong': 'Ping-pong',
  'anim.plan': '{w}×{h} · {n} frames · {fps} fps',
  'anim.limits': 'In-browser limits: ≤ {side} px, ≤ {s} s.',
  'anim.patternMotion': 'Pattern between frames',
  'anim.motion.static': 'Static',
  'anim.motion.boiling': 'Boiling',
  'anim.motion.scroll': 'Scroll',
  'anim.motionHint.static': 'Same pattern every frame; only the hidden shape moves. Easiest on the eyes.',
  'anim.motionHint.boiling': 'New dots every frame: a single frame shows nothing, the shape appears only in motion.',
  'anim.motionHint.scroll': 'The pattern slowly drifts vertically.',
  'anim.scrollSpeed': 'Speed per frame',
  'anim.generate': 'Generate animation',
  'anim.stage.depth': 'Depth',
  'anim.stage.smooth': 'Smoothing',
  'anim.stage.render': 'Frames',
  'anim.left': '{t} left',
  'anim.done': '{n} frames in {t} · {mb} MB in memory',
  'anim.exporting': 'Exporting {what}… {p}%',
  'anim.noCodec': 'This browser cannot encode this format',
  'anim.depthZip': 'Depth ZIP',
  'anim.depthZipHint': 'Depth frames as 16-bit PNGs in a ZIP',
  'anim.empty': 'Set up the animation on the left and press “Generate”',
  'player.play': 'Play',
  'player.pause': 'Pause',
  'player.prev': 'Previous frame',
  'player.next': 'Next frame',

  'heuristic.ml': 'Neural network (Depth Anything V2)',
  'source.mlHint': 'Brightness and edges are fast heuristics; the neural network gives far better depth.',
  'ml.info': 'Runs in your browser; the model (~30–50 MB) is downloaded once and cached.',
  'ml.backend': 'backend: {backend}',
  'ml.downloading': 'Downloading model {done}/{total} MB…',
  'ml.init': 'Starting the model…',
  'ml.inferring': 'Estimating depth ({backend})',
  'brush.title': 'Brush',
  'brush.hint': 'Retouch the depth map by painting on it',
  'brush.raise': 'Raise',
  'brush.lower': 'Lower',
  'brush.smooth': 'Smooth',
  'brush.flatten': 'Flatten',
  'brush.radius': 'Brush size',
  'brush.strength': 'Strength',
  'brush.undo': 'Undo stroke',
  'brush.clear': 'Clear retouching',

  'anim.video': 'Video',
  'anim.dropVideo': 'Drop a video or click to choose',
  'anim.videoHint':
    'Depth is estimated frame by frame in your browser (Depth Anything V2 Small), then smoothed over time.',
  'anim.videoTrimmed': 'Only the first {s} s will be used in the browser.',
  'anim.videoError': 'Cannot open the video: {msg}',

  'compute.client': 'Browser',
  'compute.server': 'Server',
  'compute.auto': 'Auto',
  'server.model': 'Model (home server)',
  'server.mlInfo': 'Runs on the home server GPU',
  'server.slowHint': 'This will take a while: try a lighter model or switch to in-browser mode.',
  'server.queued': 'In queue: #{n}',
  'server.running': 'On server: {p}%',
  'server.format': 'Output format',
  'server.result': 'Result from server',
  'server.download': 'Download',

  'anim.serverLimits': 'Home server limits: ≤ {side} px, ≤ {s} s.',
  'anim.serverDone': '{n} frames rendered on the server in {t}',
  'server.zipReady': 'ZIP with PNG frames is ready to download.',

  'anim.slowClientHint':
    'This is long for a browser: lower the size, duration or oversampling, or use the home server.',

  'nav.scene': 'Scene',
  'source.scene': 'Scene',
  'source.sceneHint': 'Depth of the 3D scene from the scene editor ({n} objects, t = {t} s).',
  'source.openEditor': 'Open the scene editor',
  'anim.scene': 'Scene',
  'anim.sceneHint': 'The scene timeline from the editor ({d} s) is rendered frame by frame.',
  'scene.add': 'Add',
  'scene.import': 'Import glTF / GLB / STL / OBJ',
  'scene.importError': 'Import failed: {msg}',
  'scene.loadError': 'Cannot open the scene: {msg}',
  'scene.outliner': 'Objects',
  'scene.camera': 'Camera',
  'scene.visible': 'Visible',
  'scene.emptyHint': 'The scene is empty: add an object.',
  'scene.group': 'Group selected',
  'scene.properties': 'Properties',
  'scene.selectHint': 'Select an object or the camera.',
  'scene.depthPreview': 'Depth (scene camera)',
  'scene.name': 'Name',
  'scene.parent': 'Parent',
  'scene.position': 'Position',
  'scene.rotation': 'Rotation°',
  'scene.scale': 'Scale',
  'scene.target': 'Look at',
  'scene.duplicate': 'Duplicate',
  'scene.baking': 'Building text…',
  'scene.perspective': 'Perspective',
  'scene.orthographic': 'Orthographic',
  'scene.fov': 'Field of view°',
  'scene.viewHeight': 'View height',
  'scene.near': 'Near (depth 1)',
  'scene.far': 'Far (depth 0)',
  'scene.fitDepth': 'Fit depth range',
  'scene.fitDepthHint': 'Sets near/far to the content over the whole animation',
  'scene.depthRangeHint':
    'Distances between near and far become the stereogram depth: keep the range tight around the content.',
  'scene.gizmo.translate': 'Move',
  'scene.gizmo.rotate': 'Rotate',
  'scene.gizmo.scale': 'Scale',
  'scene.throughCamera': 'Camera view',
  'scene.focus': 'Frame',
  'scene.new': 'New',
  'scene.open': 'Open…',
  'scene.save': 'Save',
  'scene.toStudio': 'Stereogram',
  'scene.toAnimate': 'Animate',
  'scene.viewportHint':
    'Drag: orbit · right-drag: pan · wheel: zoom · W/E/R: move/rotate/scale · F: frame · Ctrl+Z: undo',
  'scene.heightFromImage': 'Or load from an image:',
  'scene.presets': 'Presets…',
  'scene.preset.spin': 'Spin',
  'scene.preset.jump': 'Jump',
  'scene.preset.pulse': 'Pulse',
  'scene.preset.wave': 'Wave',
  'scene.preset.flythrough': 'Fly-through',
  'scene.addKey': 'Key',
  'scene.noKeys': 'No keyframes: moving the object changes its base pose.',
  'scene.selectForKeys': 'Select an object or the camera to edit its keyframes.',
  'scene.k.position': 'position',
  'scene.k.rotation': 'rotation',
  'scene.k.scale': 'scale',
  'scene.k.target': 'target',
  'scene.ease.linear': 'Linear',
  'scene.ease.ease_in': 'Ease in',
  'scene.ease.ease_out': 'Ease out',
  'scene.ease.ease_in_out': 'Ease in-out',
  'scene.ease.step': 'Step',
  'scene.shape.box': 'Box',
  'scene.shape.sphere': 'Sphere',
  'scene.shape.torus': 'Torus',
  'scene.shape.cylinder': 'Cylinder',
  'scene.shape.plane': 'Plane',
  'scene.shape.terrain': 'Terrain',
  'scene.shape.heightmap': 'Heightmap',
  'scene.shape.group': 'Group',
  'scene.shape.mesh': 'Mesh',
  'scene.f.size': 'Size',
  'scene.f.radius': 'Radius',
  'scene.f.tube': 'Tube',
  'scene.f.segments': 'Segments',
  'scene.f.rings': 'Rings',
  'scene.f.radiusTop': 'Top radius',
  'scene.f.radiusBottom': 'Bottom radius',
  'scene.f.height': 'Height',
  'scene.f.width': 'Width',
  'scene.f.relief': 'Relief',
  'scene.f.resolution': 'Resolution',

  'common.close': 'Close',
  'publish.button': 'Publish',
  'publish.title': 'Publish to the gallery',
  'publish.name': 'Title (optional)',
  'publish.caption': 'Caption (optional)',
  'publish.withParams': 'Share the settings (depth, texture, stereogram). The source photo is never uploaded.',
  'publish.moderation': 'Submissions appear in the gallery after moderation.',
  'publish.send': 'Send',
  'publish.sending': 'Sending…',
  'publish.done': 'Thank you! Your work will appear in the gallery after moderation.',
  'gallery.kind.all': 'All',
  'gallery.kind.static': 'Static',
  'gallery.kind.animation': 'Animated',
  'gallery.count': '{n} works',
  'gallery.empty': 'Nothing here yet.',
  'gallery.untitled': 'Untitled',
  'gallery.useSettings': 'Use these settings',
  'admin.title': 'Gallery moderation',
  'admin.toSite': '← to the site',
  'admin.logout': 'Sign out',
  'admin.login': 'Admin sign-in',
  'admin.password': 'Password',
  'admin.signIn': 'Sign in',
  'admin.notConfigured': 'The admin password is not configured on the server (STEREO_ADMIN_PASSWORD_HASH).',
  'admin.stat.total': 'total',
  'admin.stat.pending': 'pending',
  'admin.stat.approved': 'published',
  'admin.galleryEnabled': 'Gallery enabled',
  'admin.galleryDisabledByConfig': 'Disabled in the server configuration',
  'admin.status.pending': 'Pending',
  'admin.status.approved': 'Published',
  'admin.status.hidden': 'Hidden',
  'admin.status.rejected': 'Rejected',
  'admin.status.all': 'All',
  'admin.selected': '{n} selected',
  'admin.select': 'Select',
  'admin.approve': 'Approve',
  'admin.hide': 'Hide',
  'admin.reject': 'Reject',
  'admin.empty': 'No items.',
  'admin.hasParams': 'with settings',
  'admin.confirmDelete': 'Delete this item permanently?',
  'admin.confirmDeleteMany': 'Delete {n} items permanently?',

  'segment.title': 'Select object',
  'segment.hint': 'Click an object in the depth view to select it (SlimSAM, runs in the browser)',
  'segment.clickHint': 'Click an object; Shift/right-click excludes an area',
  'segment.working': 'Segmenting…',
  'segment.points': '{n} point(s)',
  'segment.flat': 'Flatten',
  'segment.tilt': 'Tilt',
  'segment.tiltHint': 'Turns the object into a sloped plane',
  'segment.amount': 'Amount',
  'segment.angle': 'Tilt direction',
  'segment.clear': 'Clear selection',

  'anim.morph': 'Morph',
  'anim.morphHint': 'Smoothly turns depth map A into B. Ping-pong playback makes a seamless loop.',
  'anim.morphStudio': 'the static source from “Create”',
  'anim.morphA': 'Depth map A (optional)',
  'anim.morphB': 'Depth map B',

  'texture.tint': 'Colour strength',

  'texture.presets': 'Ready-made textures',
  'texture.palettePreset': 'Palettes…',
  'texture.kind.mosaic': 'Mosaic / stained glass',
  'texture.kind.bubbles': 'Bubbles',
  'texture.kind.plasma': 'Plasma (psychedelic)',
  'texture.kind.rings': 'Rings / wood',
  'texture.kind.confetti': 'Confetti',
  'texture.kind.stars': 'Starry sky',
  'texture.edge': 'Seams',
  'texture.radius': 'Size',
  'texture.bands': 'Colour bands',
  'texture.rings': 'Rings',
  'texture.pieceSize': 'Piece size',
  'texture.preset.classic': 'Classic',
  'texture.preset.colorDots': 'Colour dots',
  'texture.preset.neonDots': 'Neon',
  'texture.preset.plasma': 'Plasma',
  'texture.preset.psychedelic': 'Psychedelic',
  'texture.preset.stainedGlass': 'Stained glass',
  'texture.preset.cobblestone': 'Cobblestone',
  'texture.preset.bubbles': 'Bubbles',
  'texture.preset.pebbles': 'Pebbles',
  'texture.preset.confetti': 'Confetti',
  'texture.preset.autumn': 'Autumn',
  'texture.preset.wood': 'Wood',
  'texture.preset.agate': 'Agate',
  'texture.preset.stars': 'Stars',
  'texture.preset.lava': 'Lava',
  'texture.preset.marble': 'Marble',
  'texture.preset.ocean': 'Ocean',
  'texture.preset.jungle': 'Jungle',
  'texture.preset.gold': 'Gold',
  'texture.preset.rainbowStripes': 'Rainbow',
  'palette.ocean': 'Ocean',
  'palette.sunset': 'Sunset',
  'palette.forest': 'Forest',
  'palette.candy': 'Candy',
  'palette.fire': 'Fire',
  'palette.neon': 'Neon',
  'palette.pastel': 'Pastel',
  'palette.earth': 'Earth',
  'palette.gold': 'Gold',
  'palette.ice': 'Ice',
  'palette.mono': 'Black & white',
  'palette.rainbow': 'Rainbow',

  'scene.exampleCastle': 'Example: castle',
};

export type Key = keyof typeof en;
export default en;
